// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shareCalendarWrapper_r4iuw {
	display: flex;
	align-items: flex-start;
	width: 100%;
	justify-content: flex-start;
	flex-direction: column;
	gap: 10px;
}
.meeting_jZ3cx {
	position: relative;
	display: flex;
	align-items: flex-start;
	align-items: center;
	flex-direction: column;
	gap: 4px;
	height: 45px;
	width: 100%;
	b {
		font-size: 12px;
		font-weight: 500;
	}
	.input_V57gU {
		width: 100%;
		display: flex;
		align-items: center;
		gap: 4px;
		justify-content: center;
		height: 100%;
		background: transparent;
		border: 1px solid var(--_16c09821-background);
		border-radius: 6px;
		padding: 4px 8px;
		svg {
			min-height: 16px;
			min-width: 16px;
			width: 16px;
		}
		input {
			width: 100%;
			font-size: 16px;
			border: none;
			outline: none;
			background: transparent;
		}
	}
}

.subtitle_yNl9q {
	font-size: 17px;
	font-weight: 600;
	color: var(--_3c3a3a-color);
}

.userCard_RG1l4 {
	display: flex;
	align-items: center;
	width: 100%;
	justify-content: space-between;
	padding: 6px 20px;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	border-radius: 6px;
	&:hover {
		background: var(--_16c0982e-background);
	}
}

.userCard_RG1l4:last-child {
	border-bottom: none;
}

.leftContainer_p39Tg {
	display: flex;
}
.rightContainer_A6til {
	display: flex;
	position: relative;
}

.avatar_G2Mjo {
	width: 35px;
	height: 35px;
	border-radius: 50%;
	overflow: hidden;
	margin-right: 10px;
	background-color: #f0f0f0;
	display: flex;
	align-items: center;
	justify-content: center;
}

.avatar_G2Mjo img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.initial_q9LA_ {
	font-size: 18px;
	color: var(--_10a37f-background);
	background-color: var(--_16c09821-background);
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 700;
	border-radius: 50%;
}

.userInfo_l7oAf {
	display: flex;
	height: 100%;
	justify-content: space-between;
	flex-direction: column;
}

.userName_TRgWu {
	font-size: 14px;
	line-height: 1;
	font-weight: bold;
	color: var(--_3c3a3a-color);
}

.userEmail__659j {
	font-size: 12px;
	color: #555;
}

.ownerText_aS5tR {
	font-size: 14px;
	margin-right: 8px;
}


.categoryDropdownButton_bQlqn {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;
	padding: 4px 10px;
	color: var(--_3c3a3a-color);
	gap: 7px;
	border-radius: 5px;
	&:hover {
		background: var(--_16c0982e-background);
	}
}

.permissionsDropdown_bhr_T {
	position: absolute;
	top: 100%;
	overflow: hidden;
	left: 0;
	background-color: var(--white-color);
	box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
	border-radius: 4px;
	width: 200px;
	display: flex;
	z-index: 500000;
	flex-direction: column;
}

.dropdownItem__KH8t {
	padding: 10px;
	cursor: pointer;
	color: var(--_3c3a3a-color);
	font-size: 14px;
}

.dropdownItem__KH8t:hover {
	background: var(--_16c0982e-background);
}



.categoryDropdownButton_bQlqn {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 4px 10px;
	color: var(--_3c3a3a-color);
	position: relative;
	gap: 7px;
	border-radius: 5px;
	position: relative;
	&:hover {
		background: var(--_16c0982e-background);
	}
}

.checkIcon_ovsAd {
	position: absolute;
	left: 10px;
	color: var(--e6fff9-background);
}

.roleText_WdaCF {
	margin-left: 30px;
	color: var(--_3c3a3a-color);
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/ShareCalendar.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,uBAAuB;CACvB,WAAW;CACX,2BAA2B;CAC3B,sBAAsB;CACtB,SAAS;AACV;AACA;CACC,kBAAkB;CAClB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,sBAAsB;CACtB,QAAQ;CACR,YAAY;CACZ,WAAW;CACX;EACC,eAAe;EACf,gBAAgB;CACjB;CACA;EACC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB;GACC,gBAAgB;GAChB,eAAe;GACf,WAAW;EACZ;EACA;GACC,WAAW;GACX,eAAe;GACf,YAAY;GACZ,aAAa;GACb,uBAAuB;EACxB;CACD;AACD;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,WAAW;CACX,8BAA8B;CAC9B,iBAAiB;CACjB,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,kBAAkB;CAClB;EACC,uCAAuC;CACxC;AACD;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;AACA;CACC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;CACzB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,gCAAgC;CAChC,6CAA6C;CAC7C,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,8BAA8B;CAC9B,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;;AAGA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,iBAAiB;CACjB,2BAA2B;CAC3B,QAAQ;CACR,kBAAkB;CAClB;EACC,uCAAuC;CACxC;AACD;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,gBAAgB;CAChB,OAAO;CACP,oCAAoC;CACpC,2CAA2C;CAC3C,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,2BAA2B;CAC3B,eAAe;AAChB;;AAEA;CACC,uCAAuC;AACxC;;;;AAIA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;CACjB,2BAA2B;CAC3B,kBAAkB;CAClB,QAAQ;CACR,kBAAkB;CAClB,kBAAkB;CAClB;EACC,uCAAuC;CACxC;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,+BAA+B;AAChC;;AAEA;CACC,iBAAiB;CACjB,2BAA2B;AAC5B","sourcesContent":[".shareCalendarWrapper {\n\tdisplay: flex;\n\talign-items: flex-start;\n\twidth: 100%;\n\tjustify-content: flex-start;\n\tflex-direction: column;\n\tgap: 10px;\n}\n.meeting {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: flex-start;\n\talign-items: center;\n\tflex-direction: column;\n\tgap: 4px;\n\theight: 45px;\n\twidth: 100%;\n\tb {\n\t\tfont-size: 12px;\n\t\tfont-weight: 500;\n\t}\n\t.input {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 4px;\n\t\tjustify-content: center;\n\t\theight: 100%;\n\t\tbackground: transparent;\n\t\tborder: 1px solid var(--_16c09821-background);\n\t\tborder-radius: 6px;\n\t\tpadding: 4px 8px;\n\t\tsvg {\n\t\t\tmin-height: 16px;\n\t\t\tmin-width: 16px;\n\t\t\twidth: 16px;\n\t\t}\n\t\tinput {\n\t\t\twidth: 100%;\n\t\t\tfont-size: 16px;\n\t\t\tborder: none;\n\t\t\toutline: none;\n\t\t\tbackground: transparent;\n\t\t}\n\t}\n}\n\n.subtitle {\n\tfont-size: 17px;\n\tfont-weight: 600;\n\tcolor: var(--_3c3a3a-color);\n}\n\n.userCard {\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\tjustify-content: space-between;\n\tpadding: 6px 20px;\n\tcursor: pointer;\n\tuser-select: none;\n\tborder-radius: 6px;\n\t&:hover {\n\t\tbackground: var(--_16c0982e-background);\n\t}\n}\n\n.userCard:last-child {\n\tborder-bottom: none;\n}\n\n.leftContainer {\n\tdisplay: flex;\n}\n.rightContainer {\n\tdisplay: flex;\n\tposition: relative;\n}\n\n.avatar {\n\twidth: 35px;\n\theight: 35px;\n\tborder-radius: 50%;\n\toverflow: hidden;\n\tmargin-right: 10px;\n\tbackground-color: #f0f0f0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.avatar img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.initial {\n\tfont-size: 18px;\n\tcolor: var(--_10a37f-background);\n\tbackground-color: var(--_16c09821-background);\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: 700;\n\tborder-radius: 50%;\n}\n\n.userInfo {\n\tdisplay: flex;\n\theight: 100%;\n\tjustify-content: space-between;\n\tflex-direction: column;\n}\n\n.userName {\n\tfont-size: 14px;\n\tline-height: 1;\n\tfont-weight: bold;\n\tcolor: var(--_3c3a3a-color);\n}\n\n.userEmail {\n\tfont-size: 12px;\n\tcolor: #555;\n}\n\n.ownerText {\n\tfont-size: 14px;\n\tmargin-right: 8px;\n}\n\n\n.categoryDropdownButton {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 14px;\n\tpadding: 4px 10px;\n\tcolor: var(--_3c3a3a-color);\n\tgap: 7px;\n\tborder-radius: 5px;\n\t&:hover {\n\t\tbackground: var(--_16c0982e-background);\n\t}\n}\n\n.permissionsDropdown {\n\tposition: absolute;\n\ttop: 100%;\n\toverflow: hidden;\n\tleft: 0;\n\tbackground-color: var(--white-color);\n\tbox-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);\n\tborder-radius: 4px;\n\twidth: 200px;\n\tdisplay: flex;\n\tz-index: 500000;\n\tflex-direction: column;\n}\n\n.dropdownItem {\n\tpadding: 10px;\n\tcursor: pointer;\n\tcolor: var(--_3c3a3a-color);\n\tfont-size: 14px;\n}\n\n.dropdownItem:hover {\n\tbackground: var(--_16c0982e-background);\n}\n\n\n\n.categoryDropdownButton {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 4px 10px;\n\tcolor: var(--_3c3a3a-color);\n\tposition: relative;\n\tgap: 7px;\n\tborder-radius: 5px;\n\tposition: relative;\n\t&:hover {\n\t\tbackground: var(--_16c0982e-background);\n\t}\n}\n\n.checkIcon {\n\tposition: absolute;\n\tleft: 10px;\n\tcolor: var(--e6fff9-background);\n}\n\n.roleText {\n\tmargin-left: 30px;\n\tcolor: var(--_3c3a3a-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shareCalendarWrapper": `shareCalendarWrapper_r4iuw`,
	"meeting": `meeting_jZ3cx`,
	"input": `input_V57gU`,
	"subtitle": `subtitle_yNl9q`,
	"userCard": `userCard_RG1l4`,
	"leftContainer": `leftContainer_p39Tg`,
	"rightContainer": `rightContainer_A6til`,
	"avatar": `avatar_G2Mjo`,
	"initial": `initial_q9LA_`,
	"userInfo": `userInfo_l7oAf`,
	"userName": `userName_TRgWu`,
	"userEmail": `userEmail__659j`,
	"ownerText": `ownerText_aS5tR`,
	"categoryDropdownButton": `categoryDropdownButton_bQlqn`,
	"permissionsDropdown": `permissionsDropdown_bhr_T`,
	"dropdownItem": `dropdownItem__KH8t`,
	"checkIcon": `checkIcon_ovsAd`,
	"roleText": `roleText_WdaCF`
};
export default ___CSS_LOADER_EXPORT___;
